import React, { createContext, useContext, useState } from 'react';

const initialFormState = {
  // Step 1: Details
  rotaName: '',
  location: 'Sunset Restaurant',
  monthYear: '2026-05', // "May 2026" selector format
  rotaType: 'Monthly',
  workingPattern: '',
  copyPreviousFrom: 'None',
  notes: '',
  // Step 2: Staff Selection
  selectedStaffIds: [],
  // Step 5: Notifications
  notifyOnPublish: true,
  sendReminder: true,
  includeChecksInNotification: true,
  customMessage: '',
  // Step 6: Additional Settings
  allowSwap: true,
  requireApproval: true,
  lockAfterPublish: false,
  specialDatesEvents: ''
};

const MonthlyRotaContext = createContext(undefined);

export const MonthlyRotaProvider = ({ children }) => {
  const [formData, setFormData] = useState(initialFormState);

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const resetForm = () => setFormData(initialFormState);

  return (
    <MonthlyRotaContext.Provider value={{ formData, updateField, resetForm }}>
      {children}
    </MonthlyRotaContext.Provider>
  );
};

export const useMonthlyRotaForm = () => {
  const context = useContext(MonthlyRotaContext);
  if (!context) throw new Error('useMonthlyRotaForm must be used within a MonthlyRotaProvider');
  return context;
};
